import { useEffect, useState } from 'react'
import { api } from '../services/api'

interface UpgradeStatus {
  readonly upgradeRequired: boolean
  readonly minVersion: string | null
  readonly reason: string | null
}

// Session-dismissable banner shown when the fleet-reporter has written an
// upgrade_required signal from central into local system_config. Fetches
// from /api/meta/upgrade-required (unauthenticated, reads cached state so
// no central network call is needed at runtime).
export function UpgradeRequiredBanner() {
  const [status, setStatus] = useState<UpgradeStatus | null>(null)
  const [dismissed, setDismissed] = useState(false)

  useEffect(() => {
    let cancelled = false
    api
      .get<UpgradeStatus>('/meta/upgrade-required')
      .then((res) => {
        if (!cancelled) setStatus(res.data ?? null)
      })
      .catch(() => {
        // Silently ignore — missing endpoint means no upgrade signal.
      })
    return () => {
      cancelled = true
    }
  }, [])

  if (!status?.upgradeRequired || dismissed) return null

  return (
    <div
      role="alert"
      style={{
        padding: '0.6rem 1rem',
        background: '#fef3c7',
        borderBottom: '1px solid #fde68a',
        color: '#92400e',
        fontSize: '13px',
        fontWeight: 500,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '1rem',
      }}
    >
      <span>
        System upgrade required
        {status.minVersion ? `: minimum version ${status.minVersion}` : ''}. Contact your administrator.
      </span>
      <button
        type="button"
        onClick={() => setDismissed(true)}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: '#92400e',
          fontSize: '13px',
          padding: '0 0.25rem',
          fontWeight: 700,
          flexShrink: 0,
        }}
        aria-label="Dismiss upgrade banner"
      >
        Dismiss
      </button>
    </div>
  )
}
